<template>
  <div>
    <v-text-field
      class="default-input mb-2 mt-2"
      outline
      name="search"
      v-model="search"
      hide-details
      single-line
      placeholder="Search"
      clearable
      append-icon="search"
      @click:clear="search = ''"
      style="max-width: 300px"
      @keydown.enter="onSearch"
      @input="onSearch"
      dense
      :loading="loading"
    />
    <div class="text-xs-center py-3" v-if="loading">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
    <template v-else-if="data && data.length > 0">
      <Pagination :limit="limit" :total="total" @onChange="handleChangePage">
        <v-layout wrap>
          <template v-for="item in data">
            <v-flex xs6 sm4 md3 :key="item.id" class="pa-1">
              <v-card>
                <img
                  :src="item.image_url || '/static/img/assets/_global/default-photo.png'"
                  @error="onError"
                  style="width: 100%"
                />
                <v-card-text class="text-xs-center pa-1">
                  {{ item.name || '-' }}
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    depressed
                    :outline="!selected.includes(item.id)"
                    :color="!selected.includes(item.id) ? 'black' : 'primary'"
                    @click="handleSelectProduct(item)"
                    block
                    >{{ selected.includes(item.id) ? $t('Selected') : $t('Select') }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-flex>
          </template>
        </v-layout>
      </Pagination>
    </template>
    <div v-else class="text-xs-center py-3">
      {{ $t('No product') }}
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/elements/Pagination2.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: [],
      type: Array
    }
  },
  components: {
    Pagination
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  data() {
    return {
      search: '',
      searchTimeout: null,
      loading: true,
      data: [],
      total: 0,
      selected: [],
      pageTmp: 1,
      pageNumber: 1,
      limit: 10,
      offset: 0
    }
  },
  async mounted() {
    if (this.value) {
      this.selected = this.value
    }
    this.loading = true
    try {
      const { result, total } = await this.getGiftStockControl()
      this.data = result
      this.total = total
    } catch (error) {
      console.error(error)
    }
    this.loading = false
  },
  methods: {
    async handleChangePage(page) {
      if (page) {
        const { offset = 0 } = page
        this.offset = offset
        const { result, total } = await this.getGiftStockControl()
        this.data = result
        this.total = total
      }
    },
    handleSelectProduct(item) {
      let selected = this.selected
      if (selected.includes(item.id)) {
        selected = selected.filter((product) => product != item.id)
      } else {
        selected.push(item.id)
      }
      this.selected = selected
      this.$emit('input', selected)
    },
    onError(event) {
      event.target.src = '/static/img/assets/_global/default-photo.png'
    },
    onSearch() {
      const vm = this
      if (vm.searchTimeout) {
        clearTimeout(vm.searchTimeout)
      }
      if (vm.loading) return false
      vm.searchTimeout = setTimeout(async () => {
        vm.loading = true
        try {
          vm.offset = 0
          const { result, total } = await vm.getGiftStockControl()
          vm.data = result
          vm.total = total
        } catch (error) {
          console.error(error)
        }
        vm.loading = false
        vm.searchTimeout = null
      }, 1000)
    },
    async getGiftStockControl() {
      // const { sortBy, descending, page, rowsPerPage } = this.pagination

      try {
        const data = {
          limit: this.limit,
          offset: this.offset,
          // orderby: sortBy,
          // descending,
          search: this.search,
          pageid: this.selectedBot.pageid
        }

        const response = await api.getGiveawayProduct(data)
        if (response.responsecode == 200) {
          return {
            result: response.data || [],
            total: response.total || 0
          }
        }
      } catch (error) {
        console.error(error)
      }

      return {
        result: [],
        total: 0
      }
    }
  },
  watch: {
    value: (newVal) => {
      if (newVal) {
        this.selected = newVal
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/GiftStockControl/SelectGiftStock.vue